/**
 * Throws error if CoreModule is imported elsewhere than in the PcsModule.
 *
 * @param {any} parentModule the parent module
 * @param {string} moduleName
 */
export const throwIfAlreadyLoaded = (parentModule: any, moduleName: string) => {
  if (parentModule) {
    throw new Error(`${moduleName} has already been loaded. Import Core modules in the PcsModule only.`);
  }
};
